import { PROVINCES } from '@dfl/location';
import { PAYMENT_GATEWAYS_ENUM } from 'modules/sales/settings/payment-settings/constants/payment-settings-enum';
import { isTrue } from 'utils/isTrue';

export const ALLOWED_PROVINCES = PROVINCES.filter((p) => p.acronym.match(/ART|HAB|MAY/));

export const DOMAIN = process.env.REACT_APP_DOMAIN ?? 'domain.com';

export const enablePoints = isTrue(process.env.REACT_APP_OFFERS_PRODUCT_POINT || false);

export const enableRouter = process.env.REACT_APP_OFFERS_PRODUCT_DIAMONDS === 'true';

export const ALLOWED_PAYMENT_METHODS_DEFAULT = Object.values(PAYMENT_GATEWAYS_ENUM);

export const TRANSLATION_KEY = process.env.REACT_APP_LANG_KEY || 'data-lng';

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100, 150];

export const MAX_SIZE_FILE = Number(process.env.REACT_APP_MAX_FILE_SIZE || 2) * 1024 * 1024; // 2mb
